// extracted by mini-css-extract-plugin
export default {"container":"ModalUpdate_container__SNIZB","header":"ModalUpdate_header__pwgQI","content":"ModalUpdate_content__yWudQ","footer":"ModalUpdate_footer__8Ae0X"};